<div fxLayout="column" fxLayoutAlign="start start" class="w-100">
    @if (form) {
        <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start start" class="w-100">
            <div class="grid-form-container">
                @if (form.controls.id) {
                    <div fxHide fxLayout="column" fxLayoutAlign="start start" class="w-476">
                        <mat-form-field class="w-100 mt-4">
                            <input matInput
                                   readonly
                                   formControlName="id"
                                   name="id"/>
                        </mat-form-field>
                    </div>
                }
                @if (form.controls.fraudScheme) {
                    <af-dictionary-selector dictionaryName="fraud_scheme"
                                            [control]="form.controls.fraudScheme"
                                            [predefinedValue]="form.controls?.fraudScheme?.value"
                                            label="i18n_af_labelFraudScheme"
                                            placeholder="i18n_af_placeholderFraudScheme"/>
                }
                @if (form.controls.channel) {
                    <af-dictionary-selector dictionaryName="transaction_channel"
                                            [control]="form.controls.channel"
                                            [predefinedValue]="form.controls?.channel?.value"
                                            label="i18n_af_labelChannel"
                                            [tooltip]="form.controls.channel.value
                                                ? ((form.controls.channel.value === 'ONLINE' ? 'i18n_af_tooltipChannelOnline' : 'i18n_af_tooltipChannelOffline') | translate)
                                                : ''"
                                            placeholder="i18n_af_placeholderChannel"/>
                }
                <af-dictionary-selector dictionaryName="transaction_category"
                                        [control]="form.controls.category"
                                        [excludeFromDictionary]="excludedCategories"
                                        [predefinedValue]="form.controls.category.value"
                                        [disabled]="isExistingTransaction"
                                        label="i18n_af_labelCategory"
                                        placeholder="i18n_af_placeholderCategory"/>
                <af-dictionary-selector
                    #typeSelector
                    [dictionary]="filteredTypesList"
                    [control]="form.controls.type"
                    [predefinedValue]="form.controls?.type?.value ?? transaction?.type"
                    [shouldSortDictionary]="true"
                    [disabled]="isExistingTransaction"
                    label="i18n_af_labelTransactionType"
                    [tooltip]="typeTooltipKey ? (typeTooltipKey | translate) : ''"
                    placeholder="i18n_af_placeholderTransactionType"/>
                <af-date-picker-field labelTranslationKey="i18n_af_labelDateTime"
                                      placeholderTranslationKey="i18n_af_placeholderDateTime"
                                      displayFormat="DD.MM.YYYY HH:MM"
                                      [form]="form.controls.transactionDate"
                                      [showPickerActions]="true"
                                      [supportedDateFormat]="['DDMMYYYYHHMM', 'DD.MM.YYYY HH:MM']"
                                      [dateFormats]="DATE_TIME_FORMATS"/>
                <af-dictionary-selector dictionaryName="transaction_status"
                                        [control]="form.controls.status"
                                        [predefinedValue]="form.controls?.status?.value ?? transaction?.status"
                                        [excludeFromDictionary]="excludedTransactionStatuses"
                                        [disabled]="isMiaStatusLocked"
                                        label="i18n_af_labelTransactionStatus"
                                        placeholder="i18n_af_placeholderTransactionStatus"/>
                <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <div
                        class="t5 c-primary-gray-600">{{ ('i18n_af_labelAmount') | translate }} {{ form.controls.amount.hasValidator(Validators.required) ? '*' : '' }}
                    </div>
                    <mat-form-field class="w-100 mt-4"
                                    [class.value-not-empty]="form.controls.amount.value">
                        <input matInput
                               commonsTiynTengeInput
                               formControlName="amount"
                               [placeholder]="'i18n_af_placeholderAmount' | translate"
                               name="amount"/>
                        @if (form.controls.amount.hasError('required')) {
                            <mat-error
                                class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationRequired' | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <div class="t5 c-primary-gray-600">
                        {{ ('i18n_af_labelCurrency') | translate }} {{ form.controls.currency.hasValidator(Validators.required) ? '*' : '' }}
                    </div>
                    <af-dictionary-selector dictionaryName="currency"
                                            [control]="form.controls.currency"
                                            [predefinedValue]="form.controls?.currency?.value ?? transaction?.currency"
                                            placeholder="i18n_af_placeholderCurrency">
                    </af-dictionary-selector>
                </div>
                @if (showRrnField) {
                <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <div
                        class="t5 c-primary-gray-600">{{ ('i18n_af_labelRrnBrn') | translate }} {{ form.controls.rrnBrn.hasValidator(Validators.required) ? '*' : '' }}
                    </div>
                    <mat-form-field class="w-100 mt-4"
                                    [class.value-not-empty]="form.controls.rrnBrn.valid">
                        <input matInput
                               afDigitsLatinUppercase
                               [maxlength]="MAX_RRN_BRN_LENGTH"
                               formControlName="rrnBrn"
                               [placeholder]="'i18n_af_placeholderRrnBrn' | translate"
                               name="rrnBrn"/>
                        @if (form.controls.rrnBrn.hasError('required')) {
                            <mat-error
                                class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationRequired' | translate }}
                            </mat-error>
                        }
                        @if (form.controls.rrnBrn.hasError('minlength')) {
                            <mat-error
                                class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationMinLengthRrnError' | translate }}
                            </mat-error>
                        }
                        @if (form.controls.rrnBrn.hasError('maxlength')) {
                            <mat-error
                                class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationMaxLengthRrnError' | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
                }
                @if (showPaymentIdField) {
                <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <div
                        class="t5 c-primary-gray-600">{{ ('i18n_af_labelPaymentId') | translate }} {{ form.controls.paymentId.hasValidator(Validators.required) ? '*' : '' }}
                    </div>
                    <mat-form-field class="w-100 mt-4"
                                    [class.value-not-empty]="form.controls.paymentId.value">
                        <input matInput
                               formControlName="paymentId"
                               [placeholder]="'i18n_af_placeholderId' | translate"
                               name="paymentId"/>
                        @if (form.controls.paymentId.hasError('required')) {
                            <mat-error
                                class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationRequired' | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
                }
                <af-dictionary-selector dictionaryName="client_confirmed"
                    [control]="form.controls.clientConfirmed"
                    [predefinedValue]="form.controls?.clientConfirmed?.value ?? transaction?.clientConfirmed?.toString()"
                    label="i18n_af_labelClientConfirmed"
                    placeholder="i18n_af_placeholderClientConfirmed"/>
                @if (form.controls.confirmationMethod) {
                    <af-dictionary-selector dictionaryName="confirmation_method"
                        [control]="form.controls.confirmationMethod"
                        [predefinedValue]="form.controls?.confirmationMethod?.value ?? transaction?.confirmationMethod"
                        label="i18n_af_labelConfirmationMethod"
                        placeholder="i18n_af_placeholderConfirmationMethod"/>
                }
                @if (form.controls.clientLegitimacyConfirmation) {
                    <af-dictionary-selector dictionaryName="client_legitimacy_confirmation"
                        [control]="form.controls.clientLegitimacyConfirmation"
                        [predefinedValue]="form.controls?.clientLegitimacyConfirmation?.value ?? transaction?.clientLegitimacyConfirmation"
                        label="i18n_af_labelClientLegitimacyConfirmation"/>
                }
            </div>
            @if (form.controls.attachments) {
                <af-files
                    class="w-824 mt-40"
                    hintTranslationKey="i18n_af_hintTransactionFiles"
                    [attachments]="transaction?.attachments"
                    [maxFileCount]="maxFilesCount"
                    [excludeItemsWithCode1]="true"
                    [required]="attachmentsRequired"
                    [form]="form.controls.attachments"
                    [bucket]="BucketName.TRANSACTION_FILES"/>
            }
            @if (form.controls.loanInfo; as loanInfo) {
                <div class="w-824" formGroupName="loanInfo">
                    <div class="divider w-100 mt-40"></div>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100 mt-40">
                        <div class="t2-semi-bold">{{ 'i18n_af_labelLoanInfoSection' | translate }}</div>
                        <ui-kit-button type="text"
                                       [label]="(loanInfoExpanded ? 'i18n_af_buttonCollapse' : 'i18n_af_buttonFillData') | translate"
                                       (clickListener)="loanInfoExpanded = !loanInfoExpanded"/>
                    </div>
                    @if (loanInfoExpanded) {
                    <div class="grid-form-container mt-24">
                        <af-dictionary-selector class="loan-type"
                                                dictionaryName="loan_type"
                                                [control]="loanInfo.controls.type"
                                                label="i18n_af_labelLoanType"
                                                placeholder="i18n_af_placeholderLoanType"/>
                        <af-dictionary-selector dictionaryName="loan_status"
                                                [control]="loanInfo.controls.status"
                                                label="i18n_af_labelLoanPhase"
                                                placeholder="i18n_af_placeholderLoanPhase"/>
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <div class="t5 c-primary-gray-600">
                                {{ ('i18n_af_labelLoanDocNumber') | translate }} *
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="loanInfo.controls.documentNumber.value">
                                <input matInput
                                       formControlName="documentNumber"
                                       [maxlength]="50"
                                       [placeholder]="'i18n_af_placeholderLoanDocNumber' | translate"
                                       name="documentNumber"/>
                                @if (loanInfo.controls.documentNumber.hasError('required')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <af-date-picker-field labelTranslationKey="i18n_af_labelLoanStartDate"
                                              placeholderTranslationKey="i18n_af_placeholderDate"
                                              displayFormat="DD.MM.YYYY"
                                              [form]="loanInfo.controls.startDate"
                                              [supportedDateFormat]="['DDMMYYYY', 'DD.MM.YYYY']"
                                              [dateFormats]="DATE_TIME_FORMATS"/>
                        <af-date-picker-field labelTranslationKey="i18n_af_labelLoanEndDate"
                                              placeholderTranslationKey="i18n_af_placeholderDate"
                                              displayFormat="DD.MM.YYYY"
                                              [form]="loanInfo.controls.endDate"
                                              [minDate]="loanInfo.controls.startDate?.controls.date.value ?? MIN_DATE"
                                              [maxDate]="null"
                                              [supportedDateFormat]="['DDMMYYYY', 'DD.MM.YYYY']"
                                              [dateFormats]="DATE_TIME_FORMATS"/>
                        <af-date-picker-field labelTranslationKey="i18n_af_labelLoanActualRepaymentDate"
                                              placeholderTranslationKey="i18n_af_placeholderDate"
                                              displayFormat="DD.MM.YYYY"
                                              [form]="loanInfo.controls.actualRepaymentDate"
                                              [minDate]="loanInfo.controls.startDate?.controls.date.value ?? MIN_DATE"
                                              [maxDate]="null"
                                              [supportedDateFormat]="['DDMMYYYY', 'DD.MM.YYYY']"
                                              [dateFormats]="DATE_TIME_FORMATS"/>
                        <af-date-picker-field labelTranslationKey="i18n_af_labelLoanApplicationDate"
                                              placeholderTranslationKey="i18n_af_placeholderDate"
                                              displayFormat="DD.MM.YYYY"
                                              [form]="loanInfo.controls.applicationDate"
                                              [supportedDateFormat]="['DDMMYYYY', 'DD.MM.YYYY']"
                                              [dateFormats]="DATE_TIME_FORMATS"/>
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <div class="t5 c-primary-gray-600">
                                {{ ('i18n_af_labelLoanAmount') | translate }} *
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="loanInfo.controls.amount.value">
                                <input matInput
                                       commonsTiynTengeInput
                                       formControlName="amount"
                                       [placeholder]="'i18n_af_placeholderLoanAmount' | translate"
                                       name="loanAmount"/>
                                @if (loanInfo.controls.amount.hasError('required')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <af-dictionary-selector dictionaryName="currency"
                                                [control]="loanInfo.controls.amountCurrency"
                                                label="i18n_af_labelLoanCurrency"
                                                placeholder="i18n_af_placeholderCurrency"/>
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <div class="t5 c-primary-gray-600">
                                {{ ('i18n_af_labelLoanBalance') | translate }} *
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="loanInfo.controls.balance.value">
                                <input matInput
                                       commonsTiynTengeInput
                                       formControlName="balance"
                                       [placeholder]="'i18n_af_placeholderLoanBalance' | translate"
                                       name="loanBalance"/>
                                @if (loanInfo.controls.balance.hasError('required')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <af-dictionary-selector dictionaryName="currency"
                                                [control]="loanInfo.controls.balanceCurrency"
                                                label="i18n_af_labelLoanCurrency"
                                                placeholder="i18n_af_placeholderCurrency"/>
                    </div>
                    <div class="grid-form-container mt-40">
                        <div fxLayout="column" fxLayoutAlign="start start">
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">
                                <div class="t2-semi-bold">{{ 'i18n_af_labelIsSuspended' | translate }}</div>
                                <ui-kit-checkbox [withLabel]="false" [formControl]="loanInfo.controls.isSuspended"/>
                            </div>
                            @if (loanInfo.controls.isSuspended.value) {
                                <af-dictionary-selector class="w-100 mt-24" dictionaryName="suspension_reason"
                                                        [control]="loanInfo.controls.suspensionReason"
                                                        label="i18n_af_labelSuspensionReason"
                                                        placeholder="i18n_af_placeholderSuspensionReason"/>
                                <af-date-picker-field class="mt-24"
                                                      labelTranslationKey="i18n_af_labelSuspensionDate"
                                                      placeholderTranslationKey="i18n_af_placeholderDate"
                                                      displayFormat="DD.MM.YYYY"
                                                      [form]="loanInfo.controls.suspensionDate"
                                                      [minDate]="loanInfo.controls.startDate?.controls.date.value ?? MIN_DATE"
                                                      [maxDate]="null"
                                                      [supportedDateFormat]="['DDMMYYYY', 'DD.MM.YYYY']"
                                                      [dateFormats]="DATE_TIME_FORMATS"/>
                                <div class="t5 c-primary-gray-600 mt-24">{{ 'i18n_af_labelSuspensionDocument' | translate }} *</div>
                                <af-files class="w-100 mt-4"
                                          [showTitle]="false"
                                          [required]="true"
                                          [form]="loanInfo.controls.suspensionDocuments"
                                          [filterDictionaryBy]="['LOAN_SUSPENSION']"
                                          defaultDocType="LOAN_SUSPENSION"
                                          [bucket]="BucketName.TRANSACTION_FILES"/>
                            }
                        </div>
                        <div fxLayout="column" fxLayoutAlign="start start">
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">
                                <div class="t2-semi-bold">{{ 'i18n_af_labelIsForgiven' | translate }}</div>
                                <ui-kit-checkbox [withLabel]="false" [formControl]="loanInfo.controls.isForgiven"/>
                            </div>
                            @if (loanInfo.controls.isForgiven.value) {
                                <af-dictionary-selector class="w-100 mt-24" dictionaryName="forgiveness_reason"
                                                        [control]="loanInfo.controls.forgivenessReason"
                                                        label="i18n_af_labelForgivenessReason"
                                                        placeholder="i18n_af_placeholderForgivenessReason"/>
                                <af-date-picker-field class="mt-24"
                                                      labelTranslationKey="i18n_af_labelForgivenessDate"
                                                      placeholderTranslationKey="i18n_af_placeholderDate"
                                                      displayFormat="DD.MM.YYYY"
                                                      [form]="loanInfo.controls.forgivenessDate"
                                                      [minDate]="loanInfo.controls.startDate?.controls.date.value ?? MIN_DATE"
                                                      [supportedDateFormat]="['DDMMYYYY', 'DD.MM.YYYY']"
                                                      [dateFormats]="DATE_TIME_FORMATS"/>
                                <div fxLayout="column" fxLayoutAlign="start start" class="w-100 mt-24">
                                    <div class="t5 c-primary-gray-600">
                                        {{ ('i18n_af_labelForgivenessAmount') | translate }} {{ loanInfo.controls.forgivenessAmount.hasValidator(Validators.required) ? '*' : '' }}
                                    </div>
                                    <mat-form-field class="w-100 mt-4"
                                                    [class.value-not-empty]="loanInfo.controls.forgivenessAmount.value">
                                        <input matInput
                                               commonsTiynTengeInput
                                               formControlName="forgivenessAmount"
                                               [placeholder]="'i18n_af_placeholderForgivenessAmount' | translate"
                                               name="forgivenessAmount"/>
                                        @if (loanInfo.controls.forgivenessAmount.hasError('required')) {
                                            <mat-error class="c-secondary-red-900">
                                                {{ 'i18n_af_fieldValidationRequired' | translate }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    @if (loanInfo.hasError('forgivenessAmountInvalid') && loanInfo.controls.forgivenessAmount.touched) {
                                        <div class="t5 c-secondary-red-900 mt-4">
                                            {{ 'i18n_af_fieldValidationForgivenessAmountInvalid' | translate }}
                                        </div>
                                    }
                                </div>
                                <af-dictionary-selector class="w-100 mt-24" dictionaryName="currency"
                                                        [control]="loanInfo.controls.forgivenessCurrency"
                                                        label="i18n_af_labelLoanCurrency"
                                                        placeholder="i18n_af_placeholderCurrency"/>
                                <div class="t5 c-primary-gray-600 mt-24">{{ 'i18n_af_labelForgivenessDocument' | translate }} *</div>
                                <af-files class="w-100 mt-4"
                                          [showTitle]="false"
                                          [required]="true"
                                          [form]="loanInfo.controls.forgivenessDocuments"
                                          [filterDictionaryBy]="['LOAN_FORGIVENESS']"
                                          defaultDocType="LOAN_FORGIVENESS"
                                          [bucket]="BucketName.TRANSACTION_FILES"/>
                            }
                        </div>
                    </div>
                    }
                </div>
            }
            @if (form.controls.merchantInfo) {
                <af-payment-information class="w-100" [form]="form.controls.merchantInfo"/>
            }
            @if (form.controls.sender && !isCompromisedPaymentInstrumentType) {
                <af-transaction-participant class="w-100"
                                            [participant]="transaction?.sender"
                                            label="i18n_af_labelParticipantSender"
                                            [creditRole]="form.controls.category.value === TransactionCategory.CR ? 'sender' : null"
                                            [paymentRole]="paymentTypeSelected ? 'sender' : null"
                                            [paymentOrganizationInvolved]="paymentOrganizationInvolved"
                                            [lockedSubjectType]="transferSenderSubjectType"
                                            [prefillRequisiteType]="senderPrefillRequisiteType"
                                            [phoneRequired]="transferPhoneRequired"
                                            [transferTypeSelected]="transferTypeSelected"
                                            [cashTypeSelected]="cashTypeSelected"
                                            [cashRole]="cashSenderRole"
                                            [transactionType]="form.controls.type.value"
                                            [excludedRequisiteTypes]="senderExcludedRequisiteTypes"
                                            [extraRequisiteBlocks]="senderExtraRequisiteBlocks"
                                            [participantSide]="'sender'"
                                            [transactionStatus]="form.controls.status.value"
                                            [form]="form.controls.sender"/>
            }
            @if (form.controls.receiver) {
                <af-transaction-participant class="w-100"
                                            [participant]="transaction?.receiver"
                                            label="i18n_af_labelParticipantReceiver"
                                            [creditRole]="form.controls.category.value === TransactionCategory.CR ? 'receiver' : null"
                                            [paymentRole]="paymentTypeSelected ? 'receiver' : null"
                                            [paymentOrganizationInvolved]="paymentOrganizationInvolved"
                                            [prefillRequisiteType]="receiverPrefillRequisiteType"
                                            [phoneRequired]="transferPhoneRequired"
                                            [transferTypeSelected]="transferTypeSelected"
                                            [cashTypeSelected]="cashTypeSelected"
                                            [cashRole]="cashReceiverRole"
                                            [transactionType]="form.controls.type.value"
                                            [excludedRequisiteTypes]="receiverExcludedRequisiteTypes"
                                            [extraRequisiteBlocks]="receiverExtraRequisiteBlocks"
                                            [borrowerCategoryControl]="form.controls.loanInfo?.controls.borrowerCategory"
                                            [participantSide]="'receiver'"
                                            [transactionStatus]="form.controls.status.value"
                                            [form]="form.controls.receiver"/>
            }
        </form>
    }
</div>
